const TempLogo = ({ isMobile = false }) => (
  <svg 
    width={isMobile ? "120" : "170"} 
    height={isMobile ? "32" : "46"} 
    viewBox="0 0 170 46" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style={{
      maxWidth: isMobile ? "120px" : "170px",
      height: "auto"
    }}
  >
    <path
      d="M60.9006 10C60.8665 9.57386 60.7067 9.24148 60.4212 9.00284C60.1399 8.7642 59.7116 8.64489 59.1364 8.64489C58.7699 8.64489 58.4695 8.68963 58.2351 8.77912C58.005 8.86435 57.8345 8.98153 57.7237 9.13068C57.6129 9.27983 57.5554 9.45028 57.5511 9.64205C57.5426 9.79972 57.5703 9.94247 57.6342 10.0703C57.7024 10.1939 57.8089 10.3068 57.9538 10.4091C58.0987 10.5071 58.2841 10.5966 58.5099 10.6776C58.7358 10.7585 59.0043 10.831 59.3153 10.8949L60.3892 11.125C61.1136 11.2784 61.7337 11.4808 62.2493 11.7322C62.7649 11.9837 63.1868 12.2798 63.5149 12.6207C63.843 12.9574 64.0838 13.3366 64.2372 13.7585C64.3949 14.1804 64.4759 14.6406 64.4801 15.1392C64.4759 16 64.2607 16.7287 63.8345 17.3253C63.4084 17.9219 62.799 18.3757 62.0064 18.6868C61.218 18.9979 60.2699 19.1534 59.1619 19.1534C58.0241 19.1534 57.0313 18.9851 56.1832 18.6484C55.3395 18.3118 54.6832 17.794 54.2145 17.0952C53.75 16.392 53.5156 15.4929 53.5114 14.3977H56.8864C56.9077 14.7983 57.0078 15.1349 57.1868 15.4077C57.3658 15.6804 57.6172 15.8871 57.9411 16.0277C58.2692 16.1683 58.6591 16.2386 59.1108 16.2386C59.4901 16.2386 59.8075 16.1918 60.0632 16.098C60.3189 16.0043 60.5128 15.8743 60.6449 15.7081C60.777 15.5419 60.8452 15.3523 60.8494 15.1392C60.8452 14.9389 60.7791 14.7642 60.6513 14.6151C60.5277 14.4616 60.3232 14.3253 60.0376 14.206C59.7521 14.0824 59.3665 13.9673 58.8807 13.8608L57.5767 13.5795C56.4176 13.3281 55.5036 12.9084 54.8345 12.3203C54.1697 11.728 53.8395 10.9205 53.8438 9.89773C53.8395 9.06676 54.0611 8.3402 54.5085 7.71804C54.9602 7.09162 55.5845 6.60369 56.3814 6.25426C57.1825 5.90483 58.1009 5.73011 59.1364 5.73011C60.1932 5.73011 61.1072 5.90696 61.8786 6.26065C62.6499 6.61435 63.2443 7.11293 63.6619 7.75639C64.0838 8.3956 64.2969 9.14347 64.3011 10H60.9006ZM77.1587 5.90909V19H74.1928L69.4627 12.1222H69.386V19H65.832V5.90909H68.8491L73.5025 12.7614H73.6048V5.90909H77.1587ZM78.8398 19V5.90909H88.0444V8.77273H82.3938V11.0227H87.4819V13.8864H82.3938V19H78.8398Z"
      fill="#444652"
    />
    <path
      d="M58.8807 35H53.8438V21.9091H58.8295C60.1761 21.9091 61.3395 22.1712 62.3196 22.6953C63.304 23.2152 64.0625 23.9652 64.5952 24.9453C65.1321 25.9212 65.4006 27.0909 65.4006 28.4545C65.4006 29.8182 65.1342 30.9901 64.6016 31.9702C64.0689 32.946 63.3146 33.696 62.3388 34.2202C61.3629 34.7401 60.2102 35 58.8807 35ZM57.3977 31.983H58.7528C59.4006 31.983 59.9524 31.8786 60.4084 31.6697C60.8686 31.4609 61.218 31.1009 61.4567 30.5895C61.6996 30.0781 61.821 29.3665 61.821 28.4545C61.821 27.5426 61.6974 26.831 61.4503 26.3196C61.2074 25.8082 60.8494 25.4482 60.3764 25.2393C59.9077 25.0305 59.3324 24.9261 58.6506 24.9261H57.3977V31.983ZM69.6193 35H65.7841L70.1051 21.9091H74.9631L79.2841 35H75.4489L72.5852 25.5142H72.483L69.6193 35ZM68.9034 29.8352H76.1136V32.4943H68.9034V29.8352ZM78.5346 24.7727V21.9091H89.9125V24.7727H85.975V35H82.4721V24.7727H78.5346ZM92.9982 35H89.163L93.484 21.9091H98.342L102.663 35H98.8278L95.9641 25.5142H95.8619L92.9982 35ZM92.2823 29.8352H99.4925V32.4943H92.2823V29.8352Z"
      fill="#4879F5"
    />
    <text x="53" y="43" fill="#B3B3B3" fontSize="7.2" fontFamily="Arial, sans-serif">      
      SKILLED CARE SMARTER TOOLS
    </text>
    <g clipPath="url(#clip0_876_445)">
      <path
        d="M23.0036 46.0072C35.7081 46.0072 46.0072 35.7081 46.0072 23.0036C46.0072 10.2991 35.7081 0 23.0036 0C10.2991 0 0 10.2991 0 23.0036C0 35.7081 10.2991 46.0072 23.0036 46.0072Z"
        fill="url(#paint0_linear_876_445)"
      />
      <path
        d="M25.75 30.621C27.8959 28.6539 37.7597 21.7729 37.9099 13.7832C38.0601 5.79342 27.5597 3.21124 22.9533 8.862C18.3468 3.21124 7.93227 5.79342 8.01811 13.776C8.10394 21.7586 18.0321 28.6468 20.1279 30.6138L21.0864 31.3291C21.643 31.7477 22.3227 31.9699 23.019 31.9608C23.7154 31.9518 24.3891 31.712 24.9346 31.279L25.75 30.621Z"
        fill="white"
      />
      <path
        d="M25.1995 42.3811C25.1995 42.3811 30.2065 37.7461 34.0977 36.4586C37.9888 35.1711 40.1848 32.4601 40.8285 29.9137C41.4723 27.3673 41.8228 27.1026 41.0717 26.8451C40.3207 26.5876 39.2549 30.1927 37.8744 31.473C36.4939 32.7534 33.5827 34.6418 31.3796 34.3914C29.1765 34.1411 30.371 32.7462 31.8016 32.2885C33.2322 31.8307 36.0933 30.1998 34.9775 28.8408C33.8616 27.4817 34.019 30.2714 29.6271 30.8937C25.2353 31.516 23.6116 35.1854 24.1338 37.603L25.1995 42.3811Z"
        fill="white"
      />
      <path
        d="M37.6885 31.1288C38.339 30.2116 38.9337 29.2562 39.4695 28.2676C39.7134 27.4767 39.9093 26.6717 40.0561 25.8571C40.0561 25.4923 38.8472 25.1418 38.2393 27.2233C37.8726 28.4927 37.6872 29.8075 37.6885 31.1288Z"
        fill="white"
      />
      <path
        d="M35.5352 32.5951C36.1364 32.2974 36.6946 31.9196 37.1946 31.4721C37.1946 31.4721 37.538 27.6883 37.5952 27.2234C37.6524 26.7584 36.8155 25.85 36.2504 27.7097C35.8461 29.3096 35.6064 30.9466 35.5352 32.5951Z"
        fill="white"
      />
      <path
        d="M20.8077 42.3811C20.8077 42.3811 15.8007 37.7461 11.9095 36.4586C8.01836 35.1711 5.82243 32.4601 5.17868 29.9137C4.53492 27.3673 4.18443 27.1026 4.93548 26.8451C5.68653 26.5876 6.74515 30.1927 8.12565 31.473C9.50615 32.7534 12.4174 34.6418 14.6204 34.3914C16.8235 34.1411 15.629 32.7462 14.1984 32.2885C12.7679 31.8307 9.90671 30.1998 11.0226 28.8408C12.1384 27.4817 11.981 30.2714 16.3729 30.8937C20.7647 31.516 22.3884 35.1854 21.8663 37.603L20.8077 42.3811Z"
        fill="white"
      />
      <path
        d="M8.31894 31.1288C7.66843 30.2116 7.07367 29.2562 6.53788 28.2676C6.29723 27.4836 6.10376 26.6858 5.9585 25.8786C5.9585 25.5138 7.16733 25.1633 7.77532 27.2448C8.13752 28.5076 8.32051 29.815 8.31894 31.1288Z"
        fill="white"
      />
      <path
        d="M10.4645 32.5951C9.87582 32.2946 9.32978 31.917 8.84085 31.4721C8.84085 31.4721 8.49751 27.6883 8.44029 27.2234C8.38306 26.7584 9.21995 25.85 9.78502 27.7097C10.1773 29.3108 10.405 30.9478 10.4645 32.5951Z"
        fill="white"
      />
      <path
        d="M24.513 13.9336H21.4873V22.1236H24.513V13.9336Z"
        fill="url(#paint1_linear_876_445)"
      />
      <path
        d="M27.1021 19.5413V16.5156H18.912V19.5413H27.1021Z"
        fill="url(#paint2_linear_876_445)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_876_445"
        x1="23"
        y1="-7.44873e-08"
        x2="31"
        y2="46"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#33C2F9" />
        <stop offset="1" stopColor="#4879F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_876_445"
        x1="7.03139"
        y1="-4.13451"
        x2="48.5179"
        y2="53.446"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#33C2F9" />
        <stop offset="1" stopColor="#4879F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_876_445"
        x1="7.03114"
        y1="-4.13466"
        x2="48.5177"
        y2="53.4458"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#33C2F9" />
        <stop offset="1" stopColor="#4879F5" />
      </linearGradient>
      <clipPath id="clip0_876_445">
        <rect width="46" height="46" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TempLogo;
